import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/layout/Navbar";
import Footer from "../../components/layout/Footer";
import "../../components/styles/viewActivityPage.scss";

/**
 * ViewActivityPage — Activity log table view
 * Figma: Activity log (from T2 design system)
 *
 * Layout:
 *   - Navbar
 *   - Breadcrumb: "Parental control > Selly's account > View activity" (first two gray, last bold white)
 *   - Card: "Activity log" heading
 *     - Data table with columns: Date & Time, Show Title, Duration, Device, Status
 *     - Table header: neutral_800 bg, 13px, 500 weight, neutral_400 text
 *     - 7 sample rows with activity data
 *     - Pagination at bottom
 *   - Footer
 */

const ACTIVITY_ROWS = [
  {
    id: 1,
    dateTime: "24/02/23, 22:00 WIB",
    showTitle: "Ted Lasso",
    duration: "46:00",
    device: "TV",
    status: "Badge",
  },
  {
    id: 2,
    dateTime: "24/02/23, 22:00 WIB",
    showTitle: "Ted Lasso",
    duration: "46:00",
    device: "TV",
    status: "Badge",
  },
  {
    id: 3,
    dateTime: "24/02/23, 22:00 WIB",
    showTitle: "Ted Lasso",
    duration: "46:00",
    device: "TV",
    status: "Badge",
  },
  {
    id: 4,
    dateTime: "24/02/23, 22:00 WIB",
    showTitle: "Ted Lasso",
    duration: "46:00",
    device: "TV",
    status: "Badge",
  },
  {
    id: 5,
    dateTime: "24/02/23, 22:00 WIB",
    showTitle: "Ted Lasso",
    duration: "46:00",
    device: "TV",
    status: "Badge",
  },
  {
    id: 6,
    dateTime: "24/02/23, 22:00 WIB",
    showTitle: "Ted Lasso",
    duration: "46:00",
    device: "TV",
    status: "Badge",
  },
  {
    id: 7,
    dateTime: "24/02/23, 22:00 WIB",
    showTitle: "Ted Lasso",
    duration: "46:00",
    device: "TV",
    status: "Badge",
  },
];

const ViewActivityPage = () => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = 6;

  const handlePrevious = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  return (
    <div className="view-activity-page">
      <Navbar activeTab="" />

      <div className="view-activity-page__body">
        {/* Breadcrumb */}
        <div className="view-activity-page__breadcrumb">
          <span className="view-activity-page__breadcrumb-item" onClick={() => navigate("/settings/parental")} style={{ cursor: "pointer" }}>
            Parental control
          </span>
          <span className="view-activity-page__breadcrumb-separator">
            &gt;
          </span>
          <span className="view-activity-page__breadcrumb-item" onClick={() => navigate("/settings/parental/selly")} style={{ cursor: "pointer" }}>
            Selly's account
          </span>
          <span className="view-activity-page__breadcrumb-separator">
            &gt;
          </span>
          <span className="view-activity-page__breadcrumb-item view-activity-page__breadcrumb-item--active">
            View activity
          </span>
        </div>

        {/* Card */}
        <div className="view-activity-page__card">
          <h2 className="view-activity-page__card-title">Activity log</h2>

          {/* Table */}
          <table className="view-activity-page__table">
            <thead className="view-activity-page__table-head">
              <tr className="view-activity-page__table-header-row">
                <th className="view-activity-page__table-header-cell">
                  Date & Time
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    className="view-activity-page__table-header-icon"
                  >
                    <path
                      d="M4 6L8 10L12 6"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </th>
                <th className="view-activity-page__table-header-cell">
                  Show Title
                </th>
                <th className="view-activity-page__table-header-cell">
                  Duration
                </th>
                <th className="view-activity-page__table-header-cell">
                  Device
                </th>
                <th className="view-activity-page__table-header-cell">
                  Status
                </th>
              </tr>
            </thead>
            <tbody className="view-activity-page__table-body">
              {ACTIVITY_ROWS.map((row) => (
                <tr key={row.id} className="view-activity-page__table-row">
                  <td className="view-activity-page__table-cell">
                    {row.dateTime}
                  </td>
                  <td className="view-activity-page__table-cell">
                    {row.showTitle}
                  </td>
                  <td className="view-activity-page__table-cell">
                    {row.duration}
                  </td>
                  <td className="view-activity-page__table-cell">
                    <span className="view-activity-page__device-content">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        className="view-activity-page__device-icon"
                      >
                        <rect
                          x="2"
                          y="3"
                          width="20"
                          height="14"
                          rx="2"
                          stroke="currentColor"
                          strokeWidth="1.5"
                        />
                        <path
                          d="M7 17H17"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                        />
                        <path
                          d="M9 20H15"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                        />
                      </svg>
                      {row.device}
                    </span>
                  </td>
                  <td className="view-activity-page__table-cell">
                    <span className="view-activity-page__status-badge">
                      {row.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Pagination */}
          <div className="view-activity-page__pagination">
            <button
              className="view-activity-page__pagination-btn"
              onClick={handlePrevious}
              disabled={currentPage === 1}
            >
              Previous
            </button>

            <div className="view-activity-page__page-numbers">
              {pageNumbers.map((num) => (
                <button
                  key={num}
                  className={`view-activity-page__page-number ${
                    currentPage === num
                      ? "view-activity-page__page-number--active"
                      : ""
                  }`}
                  onClick={() => setCurrentPage(num)}
                >
                  {num}
                </button>
              ))}
            </div>

            <button
              className="view-activity-page__pagination-btn"
              onClick={handleNext}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ViewActivityPage;
